import { gql } from "@apollo/client";

export const GET_SUSPECTED_ILLEGALITIES = gql`
  query GetSuspectedIllegalities(
    $page: Int
    $pageSize: Int
    $region: ID
    $district: ID
    $source: SuspectedIllegalitySource
    $status: SuspectedIllegalityStatus
    $statuses: [SuspectedIllegalityStatus]
    $origin: SuspectedIllegalityOrigin
    $search: String
    $searchFields: [String!]
    $sort: String
    $fromDate: Date
    $toDate: Date
  ) {
    rows: getSuspectedIllegalities(
      page: $page
      pageSize: $pageSize
      region: $region
      district: $district
      source: $source
      status: $status
      statuses: $statuses
      origin: $origin
      search: $search
      searchFields: $searchFields
      sort: $sort
      fromDate: $fromDate
      toDate: $toDate
    ) {
      _id
      code
      region {
        _id
        code
        name
      }
      district {
        _id
        code
        name
      }
      source
      suspectedCulprit {
        fullName
        phoneNumber
      }
      reportedBy {
        fullName
        phoneNumber
      }
      location {
        address
        community
      }
      ghanaPostAddress

      illegalityConfirmationServiceOrderCompletedAt

      status
      origin
      cancelledAt
      createdAt
      createdBy {
        ... on User {
          _id
          code
          lastName
          firstName
          ghanaCardNumber
          phoneNumber
          emailAddress
          profileImageUrl
        }
        ... on PartnerUser {
          _id
          code
          lastName
          firstName
          phoneNumber
          emailAddress
          profileImageUrl
        }
      }
    }
    count: getSuspectedIllegalitiesCount(
      region: $region
      district: $district
      origin: $origin
      status: $status
      source: $source
      search: $search
      searchFields: $searchFields
      fromDate: $fromDate
      toDate: $toDate
    )
  }
`;

export const GET_SUSPECTED_ILLEGALITIES_SUMMARY = gql`
  query GetSuspectedIllegalitiesSummary(
    $region: ID
    $district: ID
    $source: SuspectedIllegalitySource 
    $origin: SuspectedIllegalityOrigin
    $search: String
    $searchFields: [String!]
    $fromDate: Date
    $toDate: Date
  ) {
    summary: getSuspectedIllegalitiesSummary(
      region: $region
      district: $district
      source: $source
      origin: $origin
      search: $search
      searchFields: $searchFields
      fromDate: $fromDate
      toDate: $toDate
    ) {
      Pending
      OrderGenerated
      Completed
      Cancelled
    }
  }
`;

export const GET_SUSPECTED_ILLEGALITY = gql`
  query GetSuspectedIllegality($id: ID!) {
    suspectedIllegality: getSuspectedIllegality(id: $id) {
      _id
      code
      region {
        _id
        code
        name
      }
      district {
        _id
        code
        name
      }
      source
      suspectedCulprit {
        fullName
        phoneNumber
        emailAddress
      }
      reportedBy {
        fullName
        phoneNumber
        emailAddress
      }
      location {
        address
        community
      }
      ghanaPostAddress

      illegalityConfirmationServiceOrderCompletedAt
      illegalityConfirmationServiceOrderGeneratedAt
      illegalityConfirmationServiceOrderCode

      supportingImageUrls
      status
      notes
      origin
      cancelledAt
      createdAt
      
      createdBy {
        ... on User {
          _id
          code
          lastName
          firstName
          ghanaCardNumber
          phoneNumber
          emailAddress
          profileImageUrl
        }
        ... on PartnerUser {
          _id
          code
          lastName
          firstName
          phoneNumber
          emailAddress
          profileImageUrl
        }
      }
      history {
        actor {
          ... on Contractor {
            _id
            name
            code
          }
          ... on ContractorUser {
            _id
            firstName
            lastName
            username
            code
          }
          ... on MeterContractor {
            _id
            name
            code
          }
          ... on MeterContractorUser {
            _id
            firstName
            lastName
            code
          }
          ... on User {
            _id
            firstName
            lastName
            code
          }
          ... on PartnerUser {
            _id
            firstName
            lastName
            code
          }
        }
        assignee {
          ... on Contractor {
            _id
            name
            code
          }
          ... on ContractorUser {
            _id
            firstName
            lastName
            username
            code
          }
          ... on MeterContractor {
            _id
            name
            code
          }
          ... on MeterContractorUser {
            _id
            firstName
            lastName
            code
          }
          ... on User {
            _id
            firstName
            lastName
            code
          }
          ... on PartnerUser {
            _id
            firstName
            lastName
            code
          }
        }
        actorType
        assigneeType
        timestamp
        action
        notes
      }

      cancelledBy {
        ... on User {
          _id
          code
          lastName
          firstName
          ghanaCardNumber
          phoneNumber
          emailAddress
          profileImageUrl
        }
        ... on PartnerUser {
          _id
          code
          lastName
          firstName
          phoneNumber
          emailAddress
          profileImageUrl
        }
      }
      cancellationReason
    }
  }
`;




export const CREATE_SUSPECTED_ILLEGALITY = gql`
  mutation CreateSuspectedIllegality(
    $region: ID!
    $district: ID!
    $suspectedCulprit: ContactPersonInput!
    $location: SuspectedIllegalityLocationInput!
    $ghanaPostAddress: String!
    $origin: SuspectedIllegalityOrigin
    $reportedBy: ContactPersonInput
    $supportingImageUrls: [String]
    $notes: String
  ) {
    createSuspectedIllegality(
      region: $region
      district: $district
      suspectedCulprit: $suspectedCulprit
      location: $location
      ghanaPostAddress: $ghanaPostAddress
      origin: $origin
      reportedBy: $reportedBy
      supportingImageUrls: $supportingImageUrls
      notes: $notes
    ) {
      _id
    }
  }
`;

export const UPDATE_SUSPECTED_ILLEGALITY = gql`
  mutation UpdateSuspectedIllegality(
    $id: ID!
    $region: ID!
    $district: ID!
    $suspectedCulprit: ContactPersonInput!
    $location: SuspectedIllegalityLocationInput!
    $ghanaPostAddress: String
    $origin: SuspectedIllegalityOrigin
    $reportedBy: ContactPersonInput
    $supportingImageUrls: [String]
    $notes: String
  ) {
    updateSuspectedIllegality(
      id: $id
      region: $region
      district: $district
      suspectedCulprit: $suspectedCulprit
      location: $location
      ghanaPostAddress: $ghanaPostAddress
      origin: $origin
      reportedBy: $reportedBy
      supportingImageUrls: $supportingImageUrls
      notes: $notes
    ) {
      _id
    }
  }
`;

export const CANCEL_SUSPECTED_ILLEGALITY = gql`
  mutation CancelSuspectedIllegality($id: ID!, $cancellationReason: String!) {
    cancelSuspectedIllegality(
      id: $id
      cancellationReason: $cancellationReason
    ) { 
      _id
    }
  }
`;

export const GENERATE_ILLEGALITY_CONFIRMATION_SERVICE_ORDER = gql`
  mutation GenerateIllegalityConfirmationServiceOrder(
      $suspectedIllegality: ID!,
      $assignee: ID!,
      $assigneeType: SuspectedIllegalityActorType!,
      $priority: IllegalityConfirmationServiceOrderPriority!,
      $estimatedResolutionDate: Date!,
      $notes: String
  ) {
      generateIllegalityConfirmationServiceOrder(
          suspectedIllegality: $suspectedIllegality
          assignee: $assignee
          assigneeType: $assigneeType
          priority: $priority
          estimatedResolutionDate: $estimatedResolutionDate
          notes: $notes
      ) {
          _id
      }
  }
`


export const QUEUE_SERVICE_ORDER_EXPORT = gql`
  mutation QueueIllegalityConfirmationServiceOrderExport(
      $dateField: String
      $fromDate: Date
      $toDate: Date
      $region: ID
      $district: ID
      $status: SuspectedIllegalityStatus
      $origin: SuspectedIllegalityOrigin
      $description: String
  ) {
    queueSuspectedIllegalityExport(
      region: $region
      district: $district
      fromDate: $fromDate
      toDate: $toDate
      dateField: $dateField
      status: $status
      origin: $origin
      description: $description
    )
  }
`;
